<button mat-button class="h-16" [matMenuTriggerFor]="languageMenu">
  <flag class="block" [countryCode]="selectedLanguage.flag"></flag>
</button>

<mat-menu #languageMenu="matMenu" [overlapTrigger]="false">
  @for (lang of languages(); track $index) {
    <a mat-menu-item [href]="lang.url">
      <div class="flex items-center">
        <flag [countryCode]="lang.flag"></flag>
        <span class="ml-2 uppercase">{{lang.name}}</span>
      </div>
    </a>
  }
</mat-menu>
